import axios from 'axios'
import { recordingError } from './recordingErrors'

// Domain authorization must not send the separate LiveSpeaking login token.
const tokenApi = axios.create({ headers: { 'Content-Type': 'application/json' } })

export function ersStreamTokenUrl (location = typeof window !== 'undefined' ? window.location : null) {
  const local = location && ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)
  if (local || (location && process.env.NODE_ENV === 'development')) {
    return location.origin + '/api/ERS/stream/token'
  }
  return 'https://cloud.liveabc.com/api/ERS/stream/token'
}

// Axios 0.21 predates AbortSignal support; translate cancellation explicitly.
export async function fetchErsStreamToken ({ lang, signal }, api = tokenApi) {
  const source = axios.CancelToken.source()
  const abort = () => source.cancel('ERS recording cancelled')
  if (signal && signal.aborted) abort()
  else if (signal) signal.addEventListener('abort', abort, { once: true })
  try {
    source.token.throwIfRequested()
    const response = await api.post(ersStreamTokenUrl(), { lang }, {
      cancelToken: source.token, timeout: 15000
    })
    return response.data
  } catch (error) {
    if (axios.isCancel(error)) throw error
    throw recordingError(error.response && error.response.status === 401 ? 'AUTH_REQUIRED' : 'TOKEN_UNAVAILABLE')
  } finally {
    if (signal) signal.removeEventListener('abort', abort)
  }
}
